













import { computed, defineComponent, toRefs } from '~/utils/nuxt3-migration'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import { Option } from '~/models/shared/types'

export default defineComponent({
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name, options } = toRefs(props)
    const { value, error, changeValue } = useDynamicForm(props)

    function handleChange(val: number) {
      changeValue(name.value, val)
    }

    const selectOptions = computed<Option[]>(() =>
      (options.value ?? []).map((o: { label: string; value: string }) => ({
        text: o.label,
        value: o.value
      }))
    )

    return { value, error, handleChange, selectOptions }
  }
})
